import { appConfig } from '@/config/app-config';

/**
 * Будує адресу сигнального каналу.
 *
 * Формат зафіксований сервером: `/ws/{room_id}?client_id=...`. Порт `0` у Host
 * сервер відхиляє з кодом 1008 «Invalid Host (port 0)» — якщо клієнт це ловить,
 * проблема в його власному будівнику адрес, а не на сервері.
 */
export function buildSignalingUrl(roomId: string, clientId: string): string {
  const base = appConfig.webSocketBaseUrl.replace(/\/+$/u, '');
  const url = new URL(`${base}/${encodeURIComponent(roomId)}`);
  url.searchParams.set('client_id', clientId);
  return url.toString();
}
